import { getMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const GET_BRANCH_DETAILS_PROVIDER = 'GET_BRANCH_DETAILS_PROVIDER';
export const GET_BRANCH_DETAILS_PROVIDER_SUCCESS =
  'GET_BRANCH_DETAILS_PROVIDER_SUCCESS';
export const GET_BRANCH_DETAILS_PROVIDER_FAILURE =
  'GET_BRANCH_DETAILS_PROVIDER_FAILURE';

// Action Creators
export const fetchGetBranchDetailsProvider = () => ({
  type: GET_BRANCH_DETAILS_PROVIDER,
});

export const fetchGetBranchDetailsProviderSuccess = (data) => ({
  type: GET_BRANCH_DETAILS_PROVIDER_SUCCESS,
  payload: data,
});

export const fetchGetBranchDetailsProviderFailure = (error) => ({
  type: GET_BRANCH_DETAILS_PROVIDER_FAILURE,
  payload: error,
});

// Thunk Function
export const getBranchDetailsProviderCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchGetBranchDetailsProvider(data, external));
    try {
      const response = await getMethodWithToken(
        url.getBranchDetailsProvider + external?.id + '/?query=' + data?.type
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchGetBranchDetailsProviderSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchGetBranchDetailsProviderFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchGetBranchDetailsProviderFailure(error.message));
    }
  };
};
